import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isTokenExpired } from '../utils/jwt';

export default function ProtectedRoutes({ children }) {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) {
    // not logged in
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // check token expiry
  if (!token || isTokenExpired(token)) {
    // token expired or invalid: clear stored auth and redirect to login
    localStorage.removeItem('token');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userRole');
    localStorage.removeItem('userUsername');
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

ProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired
};
